import { DeviceInfo } from './DeviceInfo';
import { ConfigService } from '../services/config.service';
import { SimulatorModuleConfig } from './SimulatorModuleConfig';
import { SimulatorConfig } from './SimulatorConfig';
import { MenuLogicSnippets } from './MenuLogicSnippets';
import { MenuNode } from './MenuNode';
export class SimulatorHooks{
	_debug:boolean=true;
	debug(msg:string):void{
		if(this._debug){
			console.log("SimulatorHooks: "+ msg);
		}
	}

	boilerConfig:SimulatorModuleConfig;
	heatpumpConfig:SimulatorModuleConfig;
	config:ConfigService;
	get menuLogicSnippets():MenuLogicSnippets{
		return MenuLogicSnippets.getInstance();
	}
	set menuLogicSnippets(MenuLogicSnippets){
		
	}
	constructor(private deviceInfo:DeviceInfo){
		
	}
	setConfigService(configService:ConfigService){
		this.config = configService;
	}
	solar_buffers_unseen(){
		
		this.deviceInfo.setValue('solar_buffers_seen','false');
	}
	solar_buffers_seen(){
		this.deviceInfo.setValue('solar_buffers_seen','true');
	}

	simulatorConfig:SimulatorConfig;

	clearRecommendationSettingsAfter(node?: MenuNode){

		let id = undefined;
		if(node){
			id = node.getIdentifier();
		}
		let recommendationsettings = [
			'WIZARD_SYSTEM_SCHEME_IS_KNOWN_TO_INSTALLER_TITLE',
			'WIZARD_BOILER_QUESTION_DHW_OPTION_TITLE',
			'WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_TITLE',
			'WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE',
			'WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE',
			'WIZARD_HEATPUMP_QUESTION_POSITION_BUH_TITLE',
			'WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_TITLE',
			'WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE',
			'WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE',
			'installer_solar_buffer_options'
		];

		let idx = recommendationsettings.indexOf(id);
		let solarBufferOptionsIdx = recommendationsettings.lastIndexOf('installer_solar_buffer_options');

		if(idx >= 0 && idx < solarBufferOptionsIdx){	
			this.solar_buffers_unseen();
		}
		let is_after = false;
		for(let _id of recommendationsettings){
			if(_id == id){
				is_after = true;
			}else{
				if(is_after){
					this.deviceInfo.setValue(_id,undefined);
				}
			}
		}

	}
	setAllstorSettings(){
		if(this.menuLogicSnippets.conditions.has_aguaflow()){
			this.deviceInfo.getScale('solar_buffer_count').setCurrentValue(1);
			this.deviceInfo.setValue('wizard_solar_option','WIZARD_SOLAR_OPTIONS_ENUM4');
		}else{
			console.log("NOT SETTING SOLAR_OPTIONS");
		}
	}
	evaluateRecommendedSystemSchemeCode(){
		console.log("evaluateRecommendedSystemSchemeCode()");

		let rssc = this.deviceInfo.getScale('recommended_system_scheme_code');
		rssc.registerHook(
			'valueChanged',
			(x:any)=>{
				this.deviceInfo.getScale('systemschema_code').setCurrentValue(x);
			}
		);

		let cond = this.menuLogicSnippets.conditions;
		let getValue = (x)=>{ return this.deviceInfo.getRawValue(x) };
		if(cond.system_scheme_unknown()){
			console.log("SYSTEM SCHEME IS UNKNOWN");
			if(cond.has_aguaflow()){
				if( getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_E_HEATING_IN_BUFFER'){
						console.log("ELEKTROHEIZSTAB IM PUFFERSPEICHER");
						rssc.setCurrentValue(16);
						return;
				}
				if( getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_BOILER' || getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_NO_BUH'){
						if( getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX' ){
							console.log("KEIN WÄRMETAUSCHER");
							rssc.setCurrentValue(8);
							return;
						}
						if( getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_AVAILABLE_HEX' ){
							rssc.setCurrentValue(16);
							return;
						}
				}
				
			}

			// seite 91
			if(cond.has_one_boiler() && !cond.has_heatpump()){

				console.log("ONE BOILER; NO HEATPUMP");
				let wwValue = getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_TITLE');
				if( ['ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_COMBI_BOILER','ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_COMPACT_BOILER','ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_NO_DHW'].includes(wwValue) ){
					// kombigerät, kompaktgerät, kein WW
					rssc.setCurrentValue(1);
					return;
				}

				let solarValue = getValue('wizard_solar_option');
				console.log("SOLAR VALUE:" + solarValue);
				if( ['ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_TANK_SENSOR_AT_THE_BOILER'].includes(wwValue) ){
					if(['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2','WIZARD_SOLAR_OPTIONS_ENUM3'].includes(solarValue)){
						rssc.setCurrentValue(1);
						return;
					}
				}
				if( ['ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_TANK_SENSOR_AT_THE_BOILER'].includes(wwValue) ){
					if( ['WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solarValue) ){
						rssc.setCurrentValue(2);
						return;
					}
				}
				if(['ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_TANK_SENSOR_AT_THE_CONTROL_MODULE'].includes(wwValue) ){
					if( ['WIZARD_SOLAR_OPTIONS_ENUM5'].includes(solarValue) ){
						rssc.setCurrentValue(1);
						return;
					}
				}
				if( ['ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_TANK_SENSOR_AT_THE_CONTROL_MODULE'].includes(wwValue) ){
					if(['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2','WIZARD_SOLAR_OPTIONS_ENUM3'].includes(solarValue)){
						rssc.setCurrentValue(2);
						return;
					}
				}


			}

			if(cond.has_boilder_cascade()){
				let wwCascade = getValue('WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_TITLE');
				if(['ENUM_WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_DHW_BY_ALL_BOILERS','ENUM_WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_NO_DHW'].includes(wwCascade)){
					rssc.setCurrentValue(2);
					return;
				}
				if(['ENUM_WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_DHW_BY_LAST_BOILER'].includes(wwCascade)){
					rssc.setCurrentValue(1);
					return;	
				}
			}
			if(!cond.has_boiler()){
				
				if(cond.has_one_heatpump() &&! cond.has_allstor()){
					console.log("ONE HEATPUMP");
					/// seite 94
					if(getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_E_HEATING_IN_BUFFER'){
						console.log("ELEKTROHEIZSTAB IM PUFFERSPEICHER");
						rssc.setCurrentValue(12);
						return;
					}
				
					if(getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_E_HEATING_IN_DLOW'){
						console.log("ELEKTROHEIZSTAB IM VORLAUF");

						if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX'){
							console.log("KEIN WÄRMETAUSCHER");
							rssc.setCurrentValue(8);
							return;
						}
						if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_AVAILABLE_HEX'){
							console.log("WÄRMETAUSCHER/TRENNUNG");
							if(getValue('WIZARD_HEATPUMP_QUESTION_POSITION_BUH_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_POSITION_BUH_BUH_IN_GLYCOL_WATER'){
								console.log("IM WÄRMEPUMPENKREIS");
								rssc.setCurrentValue(11);
								return;
							}
							if(getValue('WIZARD_HEATPUMP_QUESTION_POSITION_BUH_TITLE') == 'ENUM_WIZARD_HEATPUMP_QUESTION_POSITION_BUH_BUH_IN_HEATING_CIRCUIT'){
								console.log("IM HEIZKREIS");
								if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_DHW_IN_GLYCOL_WATER'){
									console.log("IM WÄRMEPUMPENKREIS");
									rssc.setCurrentValue(10);
									return;
								}
								if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_DHW_IN_HEATING_WATER'){
									rssc.setCurrentValue(16);
									console.log("IM HEIZKREIS");
									return;
								}
							}
						}
					}
					// seite 95
					if(getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_BOILER'){
						console.log("HEIZGERÄT/KESSEL");
						if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX'){
							console.log("KEIN WÄRMETAUSCHER");
							if(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_HAP_AND_BOILER'){
								console.log("WÄRMEPUMPE UND HEIZGERÄT");
								if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_WITH_DHW_SENSOR'){
									console.log("HEIZGERÄT MIT SENSOR");
									rssc.setCurrentValue(12);
									return;
								}
								if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_W_O_DHW_SENSOR'){
									console.log("HEIZGERÄT OHNE SENSOR");
									rssc.setCurrentValue(16);
									return;
								}					
								return;
							}
							if(['ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_BOILER','ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_NO_DHW'].includes(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')) ){
								console.log("HEIZGERÄT ODER KEIN WARMWASSER");
								if(cond.has_vr7x()){
									console.log("VR7x erkannt.");
									rssc.setCurrentValue(9);
								}else{
									console.log("VR7x nicht erkannt.");
									rssc.setCurrentValue(8);
								}
								return;
							}
						}
						if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_AVAILABLE_HEX'){
							console.log("WÄRMETAUSCHER/TRENNUNG");
							if(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_HAP_AND_BOILER'){
								console.log("WÄRMEPUMPE UND HEIZGERÄT");
								if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_WITH_DHW_SENSOR'){
									console.log("HEIZGERÄT MIT SENSOR");
									rssc.setCurrentValue(13);
									return;
								}
								if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_W_O_DHW_SENSOR'){
									console.log("HEIZGERÄT OHNE SENSOR");
									rssc.setCurrentValue(16);
									return;
								}					
								return;
							}
							if(['ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_BOILER','ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_NO_DHW'].includes(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')) ){
								console.log("HEIZGERÄT ODER KEIN WARMWASSER");
								
								rssc.setCurrentValue(10);
								return;
							}
							return;
						}
					}

					if(getValue('WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_NO_BUH'){
						console.log("KEINE ZUSATZHEIZUNG");
						if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX'){
							console.log("KEIN WÄRMETAUSCHER");
							rssc.setCurrentValue(8);
							return;
						}
						if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_AVAILABLE_HEX'){
							console.log("WÄRMETAUSCHER/TRENNUNG");
							if(['ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_DHW_IN_GLYCOL_WATER','ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_NO_DHW'].includes(getValue('WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_TITLE'))){
								console.log("IM WÄRMEPUMPENKREIS ODER KEIN WARMWASSER");
								rssc.setCurrentValue(10);
								return;
							}
							if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_DHW_IN_HEATING_WATER'){
								console.log("IM HEIZKREIS");
								rssc.setCurrentValue(16);
								return;
							}
						}
					}
				}else{
					if(cond.has_one_heatpump() && cond.has_aguaflow()){
						if( getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX' ) {
							console.log("KEIN WÄRMETAUSCHER");		
							rssc.setCurrentValue(8);
							return;
						}else{
							console.log("WÄRMETAUSCHER");		
							rssc.setCurrentValue(16);
							return;
						}
					}
					if(this.simulatorConfig.heatpumpCount() > 0 && !this.simulatorConfig.hasVR7x()){
						console.log("WP-Cascade ohne VR7x");
						rssc.setCurrentValue(8);
						return;
					}

					if(this.simulatorConfig.heatpumpCount() > 0 && this.simulatorConfig.hasVR7x()){
						console.log("Heatpump-Cascade And VR7x");
						if( getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX' ) {
							console.log("KEIN WÄRMETAUSCHER");		
							if(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_HAP_AND_BOILER'){ // wp & heizgerät
								rssc.setCurrentValue(16);
								return;
							}
							if(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')=='WIZARD_ISOLATION_SWITCH_ENUM2'){ // wp1
								rssc.setCurrentValue(8);
								return;
							}
							// heizgerät
							// kein warmwasser.
							rssc.setCurrentValue(9);

							return;
						}else{
							console.log("WÄRMETAUSCHER");		
							rssc.setCurrentValue(16);
							return;
						}
					}
				}
			}else{
				console.log("HAS BOILER.");
				if(cond.has_aguaflow()){
					rssc.setCurrentValue(16);
					return;
				}
				if( getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX' ) {
					console.log("KEIN WÄRMETAUSCHER");
					if(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_HAP_AND_BOILER'){
						console.log("WAEMRMEPUMPE UND HEIZGERÄT");
						if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_WITH_DHW_SENSOR'){
							console.log("HEIZGERÄT MIT SENSOR");
							rssc.setCurrentValue(12);
							return;
						}
						if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_W_O_DHW_SENSOR'){
							console.log("HEIZGERÄT OHNE SENSOR");
							rssc.setCurrentValue(16);
							return;
						}			
					}
					if(['ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_BOILER','ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_NO_DHW'].includes(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')) ){
						console.log("HEIZGERÄT ODER KEIN WARMWASSER");
						if(cond.has_vr7x()){
							console.log("VRX im System.");
							rssc.setCurrentValue(9);
						}else{
							console.log("keine VRX im System.");
							rssc.setCurrentValue(8);
						}
						return;
					}
					return;
				}
				if(getValue('WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_AVAILABLE_HEX'){
					console.log("WÄRMETAUSCHER/TRENNUNG");
					if(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_HAP_AND_BOILER'){
						console.log("WAEMRMEPUMPE UND HEIZGERÄT");
						if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_WITH_DHW_SENSOR'){
							console.log("HEIZGERÄT MIT SENSOR");
							rssc.setCurrentValue(13);
							return;
						}
						if(getValue('WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE')=='ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_W_O_DHW_SENSOR'){
							console.log("HEIZGERÄT OHNE SENSOR");
							rssc.setCurrentValue(16);
							return;
						}			
					}
					if(['ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_BOILER','ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_NO_DHW'].includes(getValue('WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE')) ){
						console.log("HEIZGERÄT ODER KEIN WARMWASSER");
						rssc.setCurrentValue(10);
						return;
					}
					return;
				}
		

			}
		}else{
			console.log("SYSTEM SCHEME IS KNOWN");
		}

	}
	setMenuLogicSnippets(mls:MenuLogicSnippets){
		this.menuLogicSnippets = mls;
	}
	setSimulatorConfig(sc:SimulatorConfig){
		this.simulatorConfig = sc;
		this.boilerConfig = this.simulatorConfig.getModuleConfigByName('boiler');
		this.heatpumpConfig = this.simulatorConfig.getModuleConfigByName('heatPump');	
	}
	setDefaultVR71Config(){
		let sbc = this.simulatorConfig.solarCylinderCount();
		let vr71config = 3;
		if(sbc == 2){
			vr71config = 1;
		}
		if(sbc == 1){
			vr71config = 2;
		}
		if(this.simulatorConfig.hasAllStor()){
			vr71config = 6;
		}
		
		this.deviceInfo.getScale('configuration_vr71').setCurrentValue(vr71config);
	}
	afterSetup(){

		if(!this.simulatorConfig.hasVR7x() && 
			this.deviceInfo.getRawValue('wizard_zone_option') == 'WIZARD_SELECT_CIRCUIT_OPTION_ENUM2' && 
			this.simulatorConfig.hasHeatpump() && 
			this.simulatorConfig.activeHeatingCircuits() == 1
			)
		{
			
			this.deviceInfo.setZoneCount(2);
			this.config.reloadMenu();


		}
	}
	setInstallerVR71Config(){
			
		let sbc = this.deviceInfo.getScale('solar_buffer_count').getCurrentValue();
		let wso = this.deviceInfo.getRawValue('wizard_solar_option');
		let vr71config = 1;
		if(['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(wso)){
			if(sbc == 2){
				vr71config = 1;
			}
			if(sbc == 1){
				vr71config = 2;
			}
		}
		if(['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(wso)){
				vr71config = 3;
		}
		if(wso == 'WIZARD_SOLAR_OPTIONS_ENUM4'){
			vr71config = 6;
		}
		this.deviceInfo.getScale('configuration_vr71').setCurrentValue(vr71config);

		let config_screen_circuits = this.simulatorConfig.heatingCircuitCount();
		let installer_ciruits = this.deviceInfo.getScale('wizard_heatingcircuit_count').getCurrentValue();		
		let ids = this.deviceInfo.getHeatingCircuitIds();
		for(let id of ids){
			let hc = this.deviceInfo.getHeatingCircuitById(id);
			if(id > installer_ciruits){
				hc.setValue('circuitType','ENUM_TYPE_OF_CIRCUIT_DEACTIVATED');
			}
		}

	}
	getAnsteuerReihenfolge():string{
		/*
			Es ist die Anzahl der gewählten „Heizgeräte“ oder die Anzahl der „Wärmepumpen“ gemeint, 
			wenn mehr als eins gewählt wird. 
			Bei einer Kombination von mehreren Wärmepumpen und einem Heizgerät wird ist nur die Anzahl 
			der Wärmepumpen gemeint. Die Anzeige hängt nur von der Einstellung auf der Auswahlseite ab.
		*/
		let count=0;
		let hpc = this.heatpumpCount();
		if(hpc > 1){
			count = hpc;
		}
		if(hpc == 0){
			count = this.boilerCount();
		}
		let arr = new Array<string>();
		for(let i=1;i<=count;i++){
			arr.push(i.toString());
		}
		return arr.join(',');
	}

    boilerCount(){
    	return this.simulatorConfig.boilerCount();
    }
    heatpumpCount(){
        return this.simulatorConfig.heatpumpCount();
    }
}

